import { Controller } from 'stimulus';

export default class extends Controller {
  initialize() {
    this.toggleInternal();
    this.toggleReview();
  }

  toggleInternal() {
    const internalRadio = document.querySelector('input[name="document[internal]"][value="true"]');
    // The new-document form fixes the group by navigation context and omits these
    // controls (and their containers); nothing to toggle in that case.
    if (!internalRadio) return;

    const organizationContainer = document.getElementsByName('organization-container')[0];
    const classificationContainer = document.getElementsByName('classification-container')[0];
    const organizationField = document.getElementsByName('document[document_organization_id]')[0];

    if (internalRadio.checked === true) {
      $(organizationContainer).hide(500);
      $(organizationField).prop('required', false);
      $(classificationContainer).show(500);
    } else {
      $(organizationContainer).show(500);
      $(organizationField).prop('required', true);
      $(classificationContainer).hide(500);
    }
  }

  toggleReview() {
    const reviewCheckbox = document.getElementsByName('document[periodic_review_required]')[1];
    const reviewContainer = document.getElementsByName('review-container')[0];
    const reviewQuantityField = document.getElementsByName('document[review_frequency_quantity]')[0];
    const reviewIntervalField = document.getElementsByName('document[review_frequency_interval]')[0];

    if (reviewCheckbox.checked === true) {
      $(reviewContainer).show(500);
      $(reviewQuantityField).prop('required', true);
      $(reviewIntervalField).prop('required', true);
    } else {
      $(reviewContainer).hide(500);
      $(reviewQuantityField).prop('required', false);
      $(reviewIntervalField).prop('required', false);
    }
  }
}
